module.exports = __webpack_public_path__ + "img/squares.43b9c939.webp";